import MultipleSelectRectState from './multiple_select_rect_state';
import State from './state';

export default class IdleState extends State {
  constructor (context) {
    super(context);
    this.button = -1;
  }

  mouseDown (context, e) {
    this.button = e.button;

    if (this.button === 0 && !e.shiftKey) {
      this.dispose();
      return new MultipleSelectRectState(context, e);
    }

    const { clientX, clientY } = e;
    context.start.x = context.prev.x = clientX;
    context.start.y = context.prev.y = clientY;
    return this;
  }

  mouseMove (context, e) {
    const { clientX, clientY } = e;
    if (context.panable(this.button, e.shiftKey)) {
      context.pan(clientX - context.prev.x, clientY - context.prev.y);
      context.setIsPanning(true);
    }
    context.prev.x = clientX;
    context.prev.y = clientY;
    return this;
  }

  mouseUp (context, e) {
    this.button = -1;
    context.setIsPanning(false);
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/fillet/states/idle_state.js